import { PERMISSIONS } from '@/lib/permissions'

/**
 * The Documents screen — the archive of generated paper.
 *
 * `documentsRoutes` describes what to register and what the screen is gated on, so the router can
 * be wired without reading the tree. Nothing here reaches into the router itself.
 */
export { DocumentsArchivePage } from './archive'

export interface DocumentsRouteDescriptor {
  path: string
  componentName: string
  permission: string
  phoneBehaviour: 'adapts' | 'refuses'
}

export const documentsRoutes: DocumentsRouteDescriptor[] = [
  {
    path: '/documents',
    componentName: 'DocumentsArchivePage',
    permission: PERMISSIONS.documents.view,
    // Adapts. A reprint is asked for at a counter, and the counter may be a tablet. The viewer
    // itself falls back to "save a copy" where the browser cannot show a PDF inline.
    phoneBehaviour: 'adapts',
  },
]
